// extracted by mini-css-extract-plugin
module.exports = {"dropDownAction":"AttributeActionButtons_dropDownAction_1CNW9","tooltip":"AttributeActionButtons_tooltip_1u0S3"};